// v2/hooks/CartContext.js — sepet state'i tum v2 sayfalarinda ortak
import React, { createContext, useContext } from 'react';
import useCart from './useCart';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const cart = useCart();
  return <CartContext.Provider value={cart}>{children}</CartContext.Provider>;
}

export default function useCartContext() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCartContext, CartProvider icinde kullanilmali');
  return ctx;
}
